import { Link } from 'react-router-dom';
import { useState } from 'react';

const NAVIGATION_LINKS = [
  // { path: 'movement', color: 'hover:text-blue-400' },
  { path: 'archangel', color: 'hover:text-red-300' },
  { path: 'veritas', color: 'hover:text-green-400' },
  // { path: 'phantom', color: 'hover:text-purple-400' },

  // { path: 'pricing', color: 'hover:text-yellow-400' },
  { path: 'about', color: 'hover:text-yellow-400' }
];

const NavLink = ({ to, onClick, className = '', color }) => {
  const displayText = to.slice(1).replace('-', ' ').toUpperCase();

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`
        text-white font-light tracking-wide
        transition-all duration-300
        hover:opacity-100 ${color}
        hover:shadow-[0_0_15px_rgba(var(--hover-color),0.5)]
        ${className}
      `}
      style={{ '--hover-color': color }}
    >
      {displayText}
    </Link>
  );
};

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

      <div className="relative flex items-center justify-between">
        <Link to="/" className="text-white text-xl font-light tracking-wider hover:text-blue-400 transition-all duration-300 flex items-center gap-2">
          <img src="/favicon.svg" alt="Orchestra Logo" className="w-6 h-6" />
          ORCHESTRA
        </Link>

        {/* Hamburger menu button */}
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={isMenuOpen
                ? "M6 18L18 6M6 6l12 12"
                : "M4 6h16M4 12h16M4 18h16"
              }
            />
          </svg>
        </button>

        {/* Desktop menu */}
        <div className="hidden lg:flex items-center space-x-8">
          {NAVIGATION_LINKS.map(({ path, color }) => (
            <NavLink key={path} to={`/${path}`} color={color} />
          ))}
        </div>

        {/* Mobile menu */}
        <div
          className={`
            lg:hidden absolute top-full right-0 left-0 
            bg-black/90 backdrop-blur-sm 
            transition-all duration-300 
            ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
          `}
        >
          <div className="flex flex-col items-center space-y-4 py-4">
            {NAVIGATION_LINKS.map(({ path, color }) => (
              <NavLink
                key={path}
                to={`/${path}`}
                onClick={() => setIsMenuOpen(false)}
                className="w-full text-center py-2"
                color={color}
              />
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 